export const LANDING_PAGE_STATIC_NUMBERS = {
    banner: {
        countries: "15+",
        oncologists: "2000+",
    },
    multiOmics: {
        genomics: {
            total: 32368,
            start: 3000,
            wholeExome: "3,822",
            targeted: "28,546",
        },
         transcriptomics: {
            total: 4311,
            start: 3000,
            wholeExome: "2,189",
            targeted: "2,122",
        },
        proteomics: {
            start: 300, 
        }
    },
    clinicalData: {
        AvgLongitudinalFollowUpDays: {
            start: 50,
            end: 540,
        },
        MultiDimensionalClinicalData: {
            start: 50,
            value: 50,  
        },
    },
    bioBank: {
        WSI: 17500,
        dnaRnaExtract: 13500,
        ffpeBlocks: 10100,
        plasma: 3000,
  },
}